import { Component, Input, OnChanges } from '@angular/core';
// import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from 'src/app/core/services/nav.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnChanges {
  @Input() item: any | any;
  @Input() depth: any;
  @Input() isCollapsed = false;
  isExpanded = false;

  constructor(
    public navService: NavService, 
    public router: Router,
    private translateService: TranslateService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
    
    // Sử dụng ngôn ngữ từ localStorage hoặc mặc định 'vi'
    const currentLang = localStorage.getItem('lang') || 'vi';
    this.translateService.use(currentLang);
  }

  ngOnChanges() {
    this.item.isCollapsed = false;
    if (this.item.listMenus.length == 0) {
      this.item.isCollapsed = true;
    }

    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
      }
    });
  }



  onSelected(item: any) {

  }

  onItemSelected(itemParent: any, childItem: any) {
    this.router.navigate([`/${itemParent.Url}/` + childItem.Url]);
    // scroll
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
    
    // Nếu là menu "Kiểm tra" (KIEMTRA) của "Số hóa" (SOHOA), collapse sidebar
    if (itemParent.Code === 'SH' && childItem.Name === 'KIEMTRA') {
      this.navService.collapseSidebar();
    }
  }

  onSelectedItem(item: any) {
    this.router.navigate([`/${item.Url}`]);
  }

  toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }
}
